import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { WagmiPlugin } from "@wagmi/vue";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { wagmiAdapter } from "@/config";
import i18n from "./locales";
import Vant from "vant";
import "vant/lib/index.css";
import VConsole from "vconsole";

// 初始化 vConsole
// const vConsole = new VConsole();

const queryClient = new QueryClient();

createApp(App)
  .use(store)
  .use(router)
  .use(WagmiPlugin, { config: wagmiAdapter.wagmiConfig })
  .use(VueQueryPlugin, { queryClient })
  .use(Vant)
  .use(i18n)
  .mount("#app");
